export const toMap = (data) => {
  if (data === 'Error') return data;

  return data.reduce((acc, info) => {
    acc.set(info.id, {
      ...info,
      houses: new Map(info.houses.map((house) => [house.id, house])),
    });
    return acc;
  }, new Map());
};
